export default __webpack_public_path__ + "static/media/responsive.fac3bdf8.svg";